import { CONFIG } from '@/app.config';

const DisableArcadeMixin = {
  data() {
    return {
      timeout: null,
    };
  },
  methods: {
    // Evita el modo arcade, es decir, si un usuario realiza varios clicks muy seguidos
    // solo se envíará el último
    DisableArcadeMixin(fn, delay) {
      if (!delay) {
        fn();
      } else {
        const time = delay || CONFIG.ARCADE_MODE_TIME;
        if (this.timeout !== null) {
          clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
          fn();
        }, time);
      }
    },
  },
};

export default DisableArcadeMixin;
